import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import { ThemeProvider } from './context/ThemeContext';
import LandingPage from './components/LandingPage';
import ChatPage from './components/ChatPage';
import AuthPage from './components/AuthPage';
import SharedChatPage from './components/SharedChatPage';
import Dashboard from './components/Dashboard';
import ApiDocs from './components/ApiDocs';
import BlogPage from './components/BlogPage';
import BlogArticle from './components/BlogArticle';

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/chat" element={<ChatPage />} />
            <Route path="/shared/:shareId" element={<SharedChatPage />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/docs" element={<ApiDocs />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
          </Routes>
        </div>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
